// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home--sign_in {
    text-align: center;
    margin-top: 0.2em;
    margin-bottom: 0.2em;
}

.home--sign_in {
    padding: 0.6em;
    border-radius: 10px;
    margin: 0.8em;
}

.home--sign_in input {
    margin-left: 0.5em;
    margin-top: 0.3em;
    margin-bottom: 0.3em;
}

.home--sign_in button {
    margin-left: 0.5em;
    margin-top: 0.3em;
    margin-bottom: 0.3em;
}

.home--sign_in-warn {
    background-color: var(--bs-warning-bg-subtle);
}

.home--sign_in-info {
    background-color: var(--bs-info-bg-subtle);
}

.home--sign_in-divider {
    color: var(--bs-secondary);
    margin-left: 1em;
    margin-right: 1em;
    font-weight: bold;
}

.home--sign_in input {
    width: auto;
    display: inline-block;
}

.home--sign_in-validation {
    padding-inline-start: 0;
}

.home--sign_in-validation li {
    margin: 0.2em 0.5em;
    list-style-type: none;
    text-align: left;
}

@media (min-width: 768px) {
    .home--sign_in-validation li {
        display: inline-block;
    }
}

.home--sign_in-theme button {
    padding: 1em;
}

.home--upload_drop {
    min-width: 16em;
    min-height: 6em;
    background-color: #888888;
    color: white;
    text-align: center;
    padding: 4em;
    border-radius: 4px;
    cursor: pointer;
}

.home--upload_drop span {
    text-align: center;
    padding: 1em;
}

.home--upload_paste button {
    width: 100%;
}

.home--upload_paste--disabled {
    background-color: var(--bs-secondary-bg);
    color: var(--bs-secondary);
    cursor: not-allowed !important;
}

.home--upload_paste--disabled:hover {
    background-color: var(--bs-secondary-bg);
    color: var(--bs-secondary);
}

.home--upload_pick input,.home--upload_paste button {
    margin-top: 1em;
    margin-bottom: 1em;
}

.home--alert {
    cursor: pointer;
}

.thumb--frame li {
    display: inline-block;
    list-style: none;
    width: 290px;
    margin-left: 10px;
    margin-bottom: 1em;
    position: relative;
    padding: 2px;
    background-color: var(--bs-secondary-bg);
    border-radius: 4px;
}

.thumb--frame-imgbox {
    display: flex;
    height: 140px;
    width: 100%;
    margin: 2px;
    border-radius: 4px;
    justify-content: center;
    align-items: center;
}

.thumb--frame img {
    max-width: 100%;
    max-height: 100%;
}

.thumb--frame-message img {
    opacity: 0.4;
    position: absolute;

    max-width: 100%;
    max-height: 80%;
}
.thumb--frame-message span {
    position: relative;
    text-align: center;
    background-color: rgba(var(--bs-secondary-bg-rgb), 0.8);
    padding: 0.2em;
    border-radius: 4px;
}

.thumb--frame li button {
    margin-top: 4px;
    width: 100%;
}

.gallery--header {
    font-size: 140%;
    margin-bottom: 1em;
    margin-top: 1em;
}

.util--clear {
    height: 50em;
}
`, "",{"version":3,"sources":["webpack://./web/main.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,wCAAwC;IACxC,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA;IACI,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;;IAElB,eAAe;IACf,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,uDAAuD;IACvD,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".home--sign_in {\n    text-align: center;\n    margin-top: 0.2em;\n    margin-bottom: 0.2em;\n}\n\n.home--sign_in {\n    padding: 0.6em;\n    border-radius: 10px;\n    margin: 0.8em;\n}\n\n.home--sign_in input {\n    margin-left: 0.5em;\n    margin-top: 0.3em;\n    margin-bottom: 0.3em;\n}\n\n.home--sign_in button {\n    margin-left: 0.5em;\n    margin-top: 0.3em;\n    margin-bottom: 0.3em;\n}\n\n.home--sign_in-warn {\n    background-color: var(--bs-warning-bg-subtle);\n}\n\n.home--sign_in-info {\n    background-color: var(--bs-info-bg-subtle);\n}\n\n.home--sign_in-divider {\n    color: var(--bs-secondary);\n    margin-left: 1em;\n    margin-right: 1em;\n    font-weight: bold;\n}\n\n.home--sign_in input {\n    width: auto;\n    display: inline-block;\n}\n\n.home--sign_in-validation {\n    padding-inline-start: 0;\n}\n\n.home--sign_in-validation li {\n    margin: 0.2em 0.5em;\n    list-style-type: none;\n    text-align: left;\n}\n\n@media (min-width: 768px) {\n    .home--sign_in-validation li {\n        display: inline-block;\n    }\n}\n\n.home--sign_in-theme button {\n    padding: 1em;\n}\n\n.home--upload_drop {\n    min-width: 16em;\n    min-height: 6em;\n    background-color: #888888;\n    color: white;\n    text-align: center;\n    padding: 4em;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.home--upload_drop span {\n    text-align: center;\n    padding: 1em;\n}\n\n.home--upload_paste button {\n    width: 100%;\n}\n\n.home--upload_paste--disabled {\n    background-color: var(--bs-secondary-bg);\n    color: var(--bs-secondary);\n    cursor: not-allowed !important;\n}\n\n.home--upload_paste--disabled:hover {\n    background-color: var(--bs-secondary-bg);\n    color: var(--bs-secondary);\n}\n\n.home--upload_pick input,.home--upload_paste button {\n    margin-top: 1em;\n    margin-bottom: 1em;\n}\n\n.home--alert {\n    cursor: pointer;\n}\n\n.thumb--frame li {\n    display: inline-block;\n    list-style: none;\n    width: 290px;\n    margin-left: 10px;\n    margin-bottom: 1em;\n    position: relative;\n    padding: 2px;\n    background-color: var(--bs-secondary-bg);\n    border-radius: 4px;\n}\n\n.thumb--frame-imgbox {\n    display: flex;\n    height: 140px;\n    width: 100%;\n    margin: 2px;\n    border-radius: 4px;\n    justify-content: center;\n    align-items: center;\n}\n\n.thumb--frame img {\n    max-width: 100%;\n    max-height: 100%;\n}\n\n.thumb--frame-message img {\n    opacity: 0.4;\n    position: absolute;\n\n    max-width: 100%;\n    max-height: 80%;\n}\n.thumb--frame-message span {\n    position: relative;\n    text-align: center;\n    background-color: rgba(var(--bs-secondary-bg-rgb), 0.8);\n    padding: 0.2em;\n    border-radius: 4px;\n}\n\n.thumb--frame li button {\n    margin-top: 4px;\n    width: 100%;\n}\n\n.gallery--header {\n    font-size: 140%;\n    margin-bottom: 1em;\n    margin-top: 1em;\n}\n\n.util--clear {\n    height: 50em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
